var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00034 5.97486L2.02467 8.95055C1.89188 9.08334 1.73088 9.14826 1.54166 9.14531C1.35246 9.14238 1.19146 9.07452 1.05867 8.94172C0.925874 8.80893 0.859477 8.64646 0.859477 8.45431C0.859477 8.26217 0.925874 8.09971 1.05867 7.96692L4.02553 5.00006L1.04985 2.04731C0.917051 1.91452 0.852128 1.75205 0.855077 1.5599C0.85801 1.36775 0.925874 1.20528 1.05867 1.07248C1.19146 0.939689 1.35393 0.873291 1.54608 0.873291C1.73822 0.873291 1.90068 0.939689 2.03347 1.07248L5.00034 4.04817L7.95308 1.07248C8.08587 0.939689 8.24688 0.873291 8.43609 0.873291C8.62529 0.873291 8.78629 0.939689 8.91909 1.07248C9.06128 1.21469 9.13237 1.37951 9.13237 1.56696C9.13237 1.7544 9.06128 1.91452 8.91909 2.04731L5.95222 5.00006L8.92791 7.97572C9.0607 8.10851 9.1271 8.26952 9.1271 8.45873C9.1271 8.64793 9.0607 8.80893 8.92791 8.94172C8.7857 9.08391 8.62088 9.15501 8.43343 9.15501C8.24599 9.15501 8.08587 9.08391 7.95308 8.94172L5.00034 5.97486Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.95762e197c8bab4ca8fd6864bb78e982.svg";
export { ForwardRef as ReactComponent };